// extracted by mini-css-extract-plugin
export default {"container":"V1CMtFkx7pOh6NWOid1a"};